import * as types from '../constants/actionTypes';
import { wrapCall } from '../utils/serviceUtils';
import { api } from '../utils/services';

export const resetCompaniesData = (fields) => {
  return {
    type: types.RESET_COMPANIES_DATA,
    fields
  };
};
export const resetActivityCompaniesData = (fields) => {
  return {
    type: types.RESET_ACTIVTIY_COMPANIES_DATA,
    fields
  };
};
export const resetSCompaniesData = (fields) => {
  return {
    type: types.RESET_S_COMPANIES_DATA,
    fields
  };
};
export const resetSActivitiyCompaniesData = (fields) => {
  return {
    type: types.RESET_S_ACTIVTIY_COMPANIES_DATA,
    fields
  };
};

export const fetchCompanies = (search, page, perPage) => {
  return wrapCall(
    api.get(`/userB/companies?page=${page}&perPage=${perPage || 10}${search ? '&search=' + search : ''}`),
    types.FETCH_COMPANIES
  );
};
export const fetchActivityCompanies = (search, page, perPage) => {
  return wrapCall(
    api.get(`/userB/companies?page=${page}&perPage=${perPage || 10}${search ? '&search=' + search : ''}`),
    types.FETCH_ACTIVITY_COMPANIES
  );
};
export const fetchSCompanies = (search, page, perPage) => {
  return wrapCall(
    api.get(`/userB/companies?page=${page}&perPage=${perPage || 10}${search ? '&search=' + search : ''}`),
    types.FETCH_S_COMPANIES
  );
};
export const fetchSActivityCompanies = (search, page, perPage) => {
  return wrapCall(
    api.get(`/userB/companies?page=${page}&perPage=${perPage || 10}${search ? '&search=' + search : ''}`),
    types.FETCH_S_ACTIVITY_COMPANIES
  );
};

export const fetchCompanyLevels = (search, page, perPage) => {
  return wrapCall(
    api.get(`/userB/companyLevels?page=${page}&perPage=${perPage || 100}${search ? '&search=' + search : ''}`),
    types.FETCH_COMPANY_LEVELS
  );
};
